import { gameInfo, getAnnouncement } from '@/api'

export default {
  namespaced: true,
  state: {
    gameConfig: {
      guide_pic_list: [],
      appid: '',
      is_paypal_advance: false,
      paypal_client_id: '',
      mobile_login_list: [],
      pc_login_list: [],
      game_captcha_guide_pic: '',
      banner_icon: '',
    },
    bulletinList: [],
  },
  mutations: {
    SET_GAME_CONFIG: (state, gameConfig) => {
      state.gameConfig = gameConfig
    },
    SET_GAME_CONFIG_KV: (state, params) => {
      if (state.gameConfig[params.key] !== undefined) {
        state.gameConfig[params.key] = params.value
      }
    },
    SET_PAYPAL_CLIENT_ID: (state, paypal_client_id) => {
      state.gameConfig.paypal_client_id = paypal_client_id
    },
    SET_BULLETIN_LIST: (state, bulletinList) => {
      state.bulletinList = bulletinList
    },
  },
  actions: {
    async FETCH_GAME_CONFIG({ commit, rootState }, gameId) {
      try {
        const resData = await gameInfo({
          game_id: gameId,
          os: rootState.app.isMobile ? 'mobile' : 'pc',
        })
        const res = resData.data.data
        commit('SET_GAME_CONFIG', {
          ...res,
          appid: res.appid || '',
          mobile_login_list: res.mobile_login_list || ['role_id'],
          pc_login_list: res.pc_login_list || ['role_id'],
        })

        commit('app/SET_IS_PRODUCTION_TAX', res.taxed, { root: true })
      } catch (error) {}
    },
    async FETCH_BULLETIN_LIST({ commit }, params) {
      try {
        const resData = await getAnnouncement(params)
        if (resData && resData.data.code === 1) {
          commit('SET_BULLETIN_LIST', resData.data.data)
        }
      } catch (error) {}
    },
  },
}
